import React from 'react';
import { useTranslation } from 'react-i18next';
import { Languages } from 'lucide-react';

/**
 * Small language toggle: swaps between English and Bahasa Malaysia.
 * The selection is persisted in localStorage by `/src/i18n/index.js`.
 */
export default function LanguageToggle({ variant = 'chip' }) {
  const { i18n, t } = useTranslation();
  const current = i18n.language === 'en' ? 'en' : 'bm';
  const next = current === 'en' ? 'bm' : 'en';

  const swap = () => i18n.changeLanguage(next);

  if (variant === 'icon') {
    return (
      <button
        onClick={swap}
        title={t('language.toggle')}
        className="w-11 h-11 rounded-xl bg-slate-900/80 hover:bg-slate-800 border border-slate-700 flex items-center justify-center text-white transition-colors"
        data-testid="language-toggle"
      >
        <Languages className="w-5 h-5" />
        <span className="sr-only">{t('language.toggle')}</span>
      </button>
    );
  }

  return (
    <button
      onClick={swap}
      className="flex items-center gap-2 px-3 py-2 rounded-xl bg-slate-900/80 hover:bg-slate-800 border border-slate-700 text-white text-xs font-bold transition-colors"
      data-testid="language-toggle"
    >
      <Languages className="w-4 h-4 text-emerald-400" />
      <span>{current === 'en' ? 'EN' : 'BM'}</span>
    </button>
  );
}
